import React from 'react';
import { Grid, Tab } from 'semantic-ui-react';
import Navbar from '../common/Navbar';
import HomeTab from './Home/HomeTab';
import { HOMECOLUMNS, FILETYPE_CHARTER, FILETYPELABELS } from '../globals';

const Home = (props) => {
    let chartersEnabled = false;
    if ("enable_charters" in props.authUser.topData) chartersEnabled = props.authUser.topData.enable_charters;

    const panes = Object.keys(FILETYPELABELS).map((filetype) => {
        if (filetype === FILETYPE_CHARTER && !chartersEnabled) return null;
        
        return {
            menuItem: FILETYPELABELS[filetype],
            render: () => <HomeTab fileType={filetype} authUser={props.authUser} />
        }
    });

    return (
        <div className="homecontainer">
            <Navbar authUser={props.authUser} changeTop={props.changeTop} />
            <Grid centered verticalAlign="middle">
                <Grid.Row>
                    <Grid.Column {...HOMECOLUMNS}>            
                        <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </div>
    )
}

export default Home;


// WEBPACK FOOTER //
// ./src/pages/Home.js